/* eslint-disable import/prefer-default-export */
import moment from 'moment';

/**
 * This method returns a parsed date of our combined passed in date time
 * @param {string} date the date (in a full GMT standard format of year-month-day hour:minutes:seconds.milliseconds +timezoneoffset)
 * @param {string} time the time in 24:00 format
 */
export default function parseDate(date, time) {
  if (date && time) {
    const theDate = new Date(date);
    const theDayOfTheMonth = theDate.getDate();
    const theMonth = theDate.getMonth() + 1; // January is 0, not 1
    const theYear = theDate.getFullYear();
    const timezone = theDate.getTimezoneOffset();

    const parsedDateString = `${theDayOfTheMonth}/${theMonth}/${theYear} ${time}:00 ${timezone}`;
    const parsedDate = moment.parseZone(parsedDateString, 'DD/MM/YYYY HH:mm:ss ZZZ'); // preserve the time, do not convert time to local computer timezone
    return parsedDate.toISOString();
  }
  return null;
}

export const getTimeString = (date) => (date ? moment(date).utc().format('HH:mm') : null);

export const getDate = (date) => {
  if (!date) {
    return null;
  }
  const d = moment(date).utc().format('YYYY-MM-DD');
  return moment(d).valueOf();
};
